import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

import BannerEditor from "../../components/banner/bannerEditor.comp";
import Layout from "../../components/layouts/layout.comp";
import { uploadBanner } from "../../core/banner.core";
import { useTranslation } from "../../core/translation.core";
import { BannerFormData } from "../../types/banner";

export default function BannerCreatePage() {
  const { t, msg } = useTranslation();
  const router = useRouter();
  const queryClient = useQueryClient();

  const methods = useForm<BannerFormData>({
    defaultValues: {
      groupName: "header",
    },
  });

  const onSubmit = async (data: BannerFormData) => {
    const response = await uploadBanner(data);

    if (response) {
      queryClient.invalidateQueries({ queryKey: ["bannerList", data.groupName] });
      router.push("/banner");
    }
  };

  return (
    <Layout
      title={t(msg.banner.uploadBanner)}
      breadcrumbs={[
        { name: t(msg.banner.banner), link: "/banner" },
        {
          name: t(msg.banner.uploadBanner),
          link: "/banner/create",
        },
      ]}
    >
      <BannerEditor methods={methods} onSubmit={onSubmit} btnName={t(msg.banner.uploadBanner)} />
    </Layout>
  );
}
